import { getQueryString, handleError } from "../apiUtils";
import axios from "../axios";

export async function getAutomaticDownloadModes() {
  try {
    const resp = await axios.get("/api/automaticDownloadMode/?pageSize=30");
    return resp.data;
  } catch (error) {
    console.log(error);
    handleError(error);
  }
}
